module.exports = __webpack_public_path__ + "static/img/header-bg.07f34274.png";